import get from 'lodash/get';
import isObject from 'lodash/isObject';
import {AjaxFactory, HttpMethod} from '../../_libs/redux-observable-list';
import {ReduxRequest} from '../../core-utilities/redux-request';
import {isCordovaBuild} from '../../config/constants';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {getLoginUser} from '../reducers/state';
import {baseReduxRequestOptions} from './requests';
import {LOGIN_USER_PREFIX} from './state';

const reduxRequestOptions = {
  prefix: LOGIN_USER_PREFIX,
  getState: getLoginUser,
  requestFactory: buildLoginUserAjaxFactory({
    ...BASE_REDUX_LIST_OPTIONS,
  }),
  buildRequest: buildBody,
  ...baseReduxRequestOptions,
  requestErrorReducer,
};
/** @type {ReduxRequest} */
export const loginUserRequest = new ReduxRequest(reduxRequestOptions);

function buildBody(state, payload) {
  const body = {
    grantType: 'password',
    include: ['profile', 'firebaseToken'],
    username: payload.email,
    password: payload.password,
  };

  if (isCordovaBuild()) {
    body.scope = 'openid offline_access';
  } else {
    body.scope = 'openid';
  }

  return body;
}

/**
 * Endpoint does not require an auth token for obvious reasons.
 * @param options
 * @return {AjaxFactory}
 */
export function buildLoginUserAjaxFactory(options) {
  return new AjaxFactory({
    crossDomain: options.crossDomain,
    method: HttpMethod.POST,
    useBody: true,
    url: `${options.baseApiUrl}/auth/token`,
    responseType: request => 'json',
  });
}

/**
 * Exported for testing only.
 * @param {ReduxRequestState} state
 * @param {ReduxAction} action
 */
export function requestErrorReducer(state, action) {
  const err = isObject(action) ? get(action, 'payload.err.response', action) : action;
  const code = getErrorCode(err);

  return {
    ...state,
    err: code,
  };
}

export function getErrorCode(error) {
  if (!error) {
    return 'auth.error.other.message';
  }

  const errorMessage = error.error || error.message;
  const errorDescription = error.description || error.errorDescription;

  if (errorDescription === 'Wrong email or password.'
    || errorMessage === 'access_denied'
    || error.code === 'access_denied'
  ) {
    return 'auth.error.credentials.message';
  }

  // Inactive blacklist rule
  if (errorDescription.toLowerCase().contains("account access has been suspended, please contact support@ontel.co")) {
    return errorDescription;
  }

  if (error.code === 'unauthorized') {

    // Social cancel permissions or unknown error
    if (!errorDescription || errorDescription === 'access_denied') {
      return 'auth.error.other.message';
    }

    // Special case for custom rule error
    if (errorDescription === 'user is blocked') {
      return 'auth.error.blocked.message';
    }

  }

  return 'auth.error.other.message';
}



// WEBPACK FOOTER //
// ./src/js/auth/redux/loginUser.js